import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, WarningTypeOptions } from '@fleet-beat/core';

@Pipe({
  name: 'warningTypeComparePipe',
})
export class WarningTypeComparePipe implements PipeTransform {
  transform(value: unknown): string | null {
    if (!value) return null;
    return WarningTypeOptions.find((status: SelectOption) => status.value === value)?.label;
  }
}
